import qs from 'query-string';

import { SCREEN } from 'router/screens';
import { TEMPLATE_TO_ROUTE } from 'router/types';

import { InitialWebPathParams } from 'store/config/reducer.types';

const getScreenParamsFromPathName = ({
    pathName,
    query,
}: InitialWebPathParams) => {
    const BASE_NAME = document.baseURI.replace(
        `${window.location.origin}/`,
        '',
    );
    let screenName = BASE_NAME
        ? pathName
              .replace(BASE_NAME, '')
              .replace(/(?:-)+/g, '_')
              .toUpperCase()
        : pathName.replace(/(?:-)+/g, '_').toUpperCase();

    let params = query ? qs.parse(query) : undefined;

    const screenNameArray = screenName.split('/');

    if (
        params?.id &&
        TEMPLATE_TO_ROUTE[params.id as keyof typeof TEMPLATE_TO_ROUTE]
    ) {
        screenName = `${
            TEMPLATE_TO_ROUTE[params.id as keyof typeof TEMPLATE_TO_ROUTE]
        }`;
    } else if (screenNameArray.length > 1) {
        const isCollection =
            screenNameArray[screenNameArray.length - 2] === SCREEN.COLLECTION;
        const isDetails =
            screenNameArray[screenNameArray.length - 2] === SCREEN.DETAILS;
        const screenDestination =
            isDetails || isCollection
                ? screenNameArray[screenNameArray.length - 2]
                : screenNameArray[screenNameArray.length - 1];

        // eslint-disable-next-line prefer-destructuring
        screenName = screenNameArray[0];
        params = {
            // @ts-ignore
            params: {
                ...params,
                ...(isDetails && {
                    programName: screenNameArray[screenNameArray.length - 1],
                }),
                ...(isCollection && {
                    title: screenNameArray[screenNameArray.length - 1],
                }),
            },
            screen: screenDestination,
        };
    } else if (screenName === 'TV') {
        screenName = TEMPLATE_TO_ROUTE['TV Mobile'];
    }

    return {
        screen: screenName,
        params,
    };
};

export default getScreenParamsFromPathName;
